// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charte-achats-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  width: 100%;
  padding: 2rem;
  margin: 0 !important;
}

.charte-achats-container {
  max-width: inherit !important;
  margin: 0 !important;
}

.charte-achats-paragraph {
  margin-bottom: 1em;
}

.charte-achats-ul {
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 1em;
}

.charte-achats-title-h1 {
  color: #ffa500;
}

.charte-achats-title-h2 {
  color: #ffa500;
}

.charte-achats-title-h3 {
  color: #ffa500;
}

.charte-achats-title-h4 {
  color: #ffa500;
  margin-top: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CharteAchatsDurables/CharteAchatsDurables.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".charte-achats-page {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  width: 100%;\n  padding: 2rem;\n  margin: 0 !important;\n}\n\n.charte-achats-container {\n  max-width: inherit !important;\n  margin: 0 !important;\n}\n\n.charte-achats-paragraph {\n  margin-bottom: 1em;\n}\n\n.charte-achats-ul {\n  list-style-type: disc;\n  margin-left: 20px;\n  margin-bottom: 1em;\n}\n\n.charte-achats-title-h1 {\n  color: #ffa500;\n}\n\n.charte-achats-title-h2 {\n  color: #ffa500;\n}\n\n.charte-achats-title-h3 {\n  color: #ffa500;\n}\n\n.charte-achats-title-h4 {\n  color: #ffa500;\n  margin-top: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
